var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"rfid"}},[_c('v-container',[_c('DescriptionComp'),_c('VentajasComp'),_c('CuentanosComp')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }